export default ({ onChange }) => {
  return (
    <div className="form-check file-select-control">
      <input type="checkbox" className="form-check-input" name="selected" onChange={onChange} />
    </div>
  )
}
